<div class="container pt-20 pb-20 d-none d-lg-block">
  <div class="glass-back-button" [routerLink]="backButtonLink">
    <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
  </div>
</div>

<!-- Points Summary -->
<div class="container d-lg-none">
  <fgb-points-summary-bar [backButtonLink]="backButtonLink"></fgb-points-summary-bar>
</div>
<fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>

<div class="container"></div>
